import * as React from 'react';
export const IcTechnology = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.57 19L15 13.83c.203-.324.352-.678.44-1.05l3-.21a1.469 1.469 0 001.06.43 1.5 1.5 0 100-3 1.47 1.47 0 00-1.17.58l-3.06.2a3.362 3.362 0 00-.47-.85l3-3.95.2.02a2 2 0 10-2-2 1.92 1.92 0 00.16.79l-3 3.94a3.22 3.22 0 00-2-.13L9 4.7a1.362 1.362 0 000-.2A1.5 1.5 0 107.41 6l2.06 3.6a3.56 3.56 0 00-.75 1.22l-4.05-.24a1.5 1.5 0 10-.11 2l4 .24c.11.458.31.89.59 1.27L6.23 18H6a2 2 0 102 2 2.1 2.1 0 00-.16-.79l2.95-3.94c.154.059.31.11.47.15l.16 2a1.48 1.48 0 00-.42 1 1.5 1.5 0 102.845-.66 1.469 1.469 0 00-.435-.52l-.16-2.06.24-.1 4.51 5.2A1.5 1.5 0 1019.57 19z'
      fill='currentColor'
    />
  </svg>
);
